import React, { PureComponent } from 'react';

import { injectIntl, defineMessages } from 'react-intl';

import EmailEditor from 'react-email-editor';

import * as templateLib from 'libs/templateLib';

import classNames from 'classnames/bind';
import styles from './HtmlEditor.css';
const cx = classNames.bind(styles);

class HtmlEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.editor;
  }

  onChangeEditor = data => {
    const type = data.type; // body, row, content
    const item = data.item;
    const changes = data.changes;
    console.log('design:updated', type, item, changes);

    // 이미지 업로드
    this.editor.registerCallback('image', (file, done) => this.uploadBodyImage(file, done));
  };

  onLoad = () => {
    this.editor.addEventListener('design:updated', this.onChangeEditor);
  };

  onDesignLoad = data => {
    console.log('onDesignLoad', data);
  };

  saveDesign = () => {
    this.editor.saveDesign(design => {
      console.log('saveDesign', design);
    });
  };

  exportHtml = () => {
    this.editor.exportHtml(data => {
      const { design, html } = data;
      console.log('exportHtml', html);
    });
  };

  uploadBodyImage = async (file, done) => {
    try {
      const { templateInfo: { templateNo, serviceTemplateNo } } = this.props;

      const data = new FormData();
      if (!!!serviceTemplateNo) {
        data.append('examTemplateNo', templateNo);
      } else {
        data.append('serviceTemplateNo', serviceTemplateNo);
      }
      data.append('file', file.attachments[0]);

      const respObj = await templateLib.uploadExamTemplateBodyImage(data);
      if (respObj && respObj.status && respObj.status === 200) {
        if (respObj.data && respObj.data.link) {
          done({ progress: 100, url: respObj.data.link });

          return respObj.data.location;
        }
      } else {
        // 응답 오류
      }

      return null;
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { readOnly, locale, value, className } = this.props;

    return (
      <div className={cx('editor', { className })}>
        <EmailEditor
          className={cx('editor-content')}
          ref={editor => (this.editor = editor)}
          onLoad={this.onLoad}
          readOnly={readOnly}
        />
        <button onClick={this.exportHtml}>exportHtml</button>
        <button onClick={this.saveDesign}>saveDesign</button>
      </div>
    );
  }
}

export default injectIntl(HtmlEditor);



// WEBPACK FOOTER //
// ./src/script/components/common/HtmlEditor.js